
<template>
  <div>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-card class="mx-auto">
      <vdata-table
        :page="page"
        :pageCount="numberOfPages"
        :items-per-page="itemsPerPage"
        :items="places"
        :headers="headers"
        :counties="counties"
        :neighborhoods="neighborhoods"
        :groupId="groupId"
        @fileUploaded="fileUploaded"
        @placeClick="placeClick"
        @placeReClick="placeReClick"
      >
      </vdata-table>
    </v-card>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  props: {
    groupId: String,
    filter: Object,
    counties: Array,
    neighborhoods: Array,
  },
  data() {
    return {
      categories: [],
      totalCount: 0,
      page: 0,
      numberOfPages: 5,
      itemsPerPage: 5,
      totalItemsPerPage: 10000,
      options: {},
      overlay: true,
    };
  },
  async created() {
    console.log("places are refreshing due to creating");
    await this.refreshTable();
  },
  computed: {
    ...mapGetters({ items: "places/items" }),
    headers() {
      return [
        {
          text: this.$t("_place.name"),
          sortable: true,
          value: "name",
        },
        {
          text: this.$t("_place.address"),
          sortable: true,
          value: "address",
        },
        {
          text: this.$t("_place.county"),
          sortable: true,
          value: "countyName",
        },
        {
          text: this.$t("_place.neighborhood"),
          sortable: true,
          value: "neighborhoodName",
        },
        {
          text: this.$t("_place.lat"),
          sortable: false,
          value: "lat",
        },
        {
          text: this.$t("_place.lon"),
          sortable: false,
          value: "lon",
        },
        {
          text: this.$t("_place.phone"),
          sortable: true,
          value: "phone",
          divider: true,
        },

        {
          text: this.$t("_place.actions"),
          value: "actions",
          sortable: false,
          align: "right",
          width: 180,
          divider: false,
        },
      ];
    },
    places() {
      return this.items.map((item) =>
        Object.assign({}, item, {
          countyName: (
            this.counties.find((county) => county.code === item.countyCode) ||
            {}
          ).name,
          neighborhoodName: (
            this.neighborhoods.find(
              (neighborhood) => neighborhood.code === item.neighborhoodCode
            ) || {}
          ).name,
        })
      );
    },
  },
  methods: {
    ...mapActions(["places/getItems"]),

    async refreshTable() {
      let filterr = JSON.parse(JSON.stringify(this.filter));
      filterr.categoryIds.push(this.groupId);
      await this.$store.dispatch("places/getItems", {
        page: this.page,
        itemsPerPage: this.totalItemsPerPage,
        filter: filterr,
      });
      this.overlay = false;
    },
    fileUploaded() {
      // hide a dialog
      this.refreshTable();
      // save a user and refresh a table
    },
    placeClick(item) {
      console.log("placetable", item);
      this.$emit("mapPlace", item);
    },
    placeReClick() {
      console.log("reclick");
      this.$emit("mapRePlace");
    },
  },

  watch: {
    groupId() {
      this.$emit("update:groupId", this.groupId);
      this.overlay = true;

      this.refreshTable();
    },
    options: {
      handler() {
        this.refreshTable();
      },
      deep: true,
    },
    language: function () {
      console.log("lang changed");
      this.refreshTable();
    },
    filter: {
      handler() {
        this.refreshTable();
      },
      deep: true,
    },
  },
};
</script>